import React from 'react'

const FeedbackCard = ({ title, content }) => {
  return (
    <div className="bg-white dark:bg-gray-700 shadow-lg rounded-lg p-5 border border-gray-200 dark:border-gray-600 hover:shadow-xl transition">
      <p className="mt-2 text-gray-600 dark:text-gray-200">{content}</p>
      <h3 className="flex items-center gap-2 mt-3 font-bold text-lg text-gray-900 dark:text-gray-100">
        {title}
      </h3>
    </div>
  )
}

export default FeedbackCard
